import React from 'react';
import Header from './Header';
import { config, appVariant } from '../../config';
import { getPackHeader } from '../../config/packHeader';

interface HeaderProps {
  title?: string;
  leftButton?: {
    icon: React.ReactNode;
    onClick: () => void;
    tooltip?: string;
  };
  rightButton?: {
    icon: React.ReactNode;
    onClick: () => void;
    tooltip?: string;
  };
  rightContent?: React.ReactNode;
  centerContent?: React.ReactNode;
  roomCode?: string;
  subtitle?: string;
  logo?: {
    src: string;
    url: string;
    alt?: string;
  };
  premiumLink?: {
    onClick: () => void;
  };
}

interface AppHeaderProps extends Omit<HeaderProps, 'title' | 'subtitle' | 'logo'> {
  // Allow override of title/subtitle/logo if needed
  title?: string;
  subtitle?: string;
  logo?: {
    src: string;
    url: string;
    alt?: string;
  } | null; // null explicitly disables logo, undefined uses default from config
  isPremium?: boolean;
  showLanguageSelector?: boolean;
}

/**
 * AppHeader is a wrapper around Header. Default title/subtitle use pack header
 * (e.g. "Toyo Blitz" / "Only one can win!") so all screens show the same 2-row design.
 */
export const AppHeader: React.FC<AppHeaderProps> = ({
  title,
  subtitle,
  logo,
  isPremium,
  ...headerProps
}) => {
  const pack = getPackHeader(appVariant);
  return (
    <Header
      {...headerProps}
      title={title ?? pack.name}
      subtitle={subtitle ?? pack.phrase}
      logo={logo === null ? undefined : (logo !== undefined ? logo : (config.logo && config.homeUrl ? {
        src: config.logo,
        url: config.homeUrl,
        alt: config.appName,
      } : undefined))}
      isPremium={isPremium}
    />
  );
};
